import auth from "./middleware/auth";

export default [
  {
    path: "/",
    name: "Vehicles",
    component: require("@/views/Vehicles/List").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: ":id",
    name: "Vehicle",
    component: require("@/views/Vehicles/Item").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: ":vehicleId/activity",
    name: "VehicleActivity",
    component: require("@/views/Vehicles/Activity").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: ":vehicleId/documents",
    name: "VehicleDocuments",
    component: require("@/views/VehicleDocuments/List").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: ":vehicleId/documents/:id",
    name: "VehicleDocument",
    component: require("@/views/VehicleDocuments/Item").default,
    meta: {
      middleware: auth,
    },
  },
];
